import { auditReports } from '@mi-front/api-clients';
import { Box } from '@mui/material';
import { CircularProgressWithLabel } from '../../../../../components/base/CircularProgressWithLabel';
import { AodRunStatus } from './AodRunStatus';

interface AodRunStatusWithProgressProps {
  run: auditReports.AodRun;
  size?: 'small' | 'medium';
}

export function AodRunStatusWithProgress({ run, size = 'small' }: AodRunStatusWithProgressProps) {
  const { status, processJobStatus } = run;

  const processProgress =
    status === auditReports.AodRunStatusEnum.IN_PROGRESS && processJobStatus?.progressPercent;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <AodRunStatus showEfficiency={false} run={run} size={size} />
      {processProgress && (
        <CircularProgressWithLabel
          value={processProgress as number}
          size={size === 'small' ? 32 : 48}
        />
      )}
    </Box>
  );
}
